import React from 'react';
import './HeatMapSkeleton.css';

const HeatMapSkeleton = () => {
  // Количество колонок (типов обучений + сотрудник + общий статус)
  const columnCount = 9; // 1 сотрудник + 7 типов + 1 общий статус
  const rowCount = 10; // Количество строк-скелетонов

  return (
    <div className="heatmap-container">
      {/* Header skeleton */}
      <div className="heatmap-header">
        <div className="skeleton skeleton-title"></div>
        <div className="skeleton skeleton-subtitle"></div>
      </div>

      {/* Legend skeleton */}
      <div className="legend skeleton-legend">
        <div className="skeleton skeleton-legend-title"></div>
        <div className="legend-items">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="legend-item">
              <div className="skeleton skeleton-legend-color"></div>
              <div className="skeleton skeleton-legend-text"></div>
              <div className="skeleton skeleton-legend-count"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Filters skeleton */}
      <div className="filters-bar">
        <div className="search-box">
          <div className="skeleton skeleton-search"></div>
        </div>
        <div className="filter-group">
          <div className="skeleton skeleton-filter-label"></div>
          <div className="skeleton skeleton-filter-select"></div>
        </div>
        <div className="filter-group">
          <div className="skeleton skeleton-filter-label"></div>
          <div className="skeleton skeleton-filter-select"></div>
        </div>
        <div className="skeleton skeleton-refresh-btn"></div>
      </div>

      {/* Table skeleton */}
      <div className="heatmap-table-wrapper">
        <table className="heatmap-table">
          <thead>
            <tr>
              <th className="employee-col">
                <div className="skeleton skeleton-th"></div>
              </th>
              {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                <th key={i} className="training-col-vertical">
                  <div className="skeleton skeleton-th-short"></div>
                </th>
              ))}
              <th className="status-col-vertical">
                <div className="skeleton skeleton-th-short"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Brigade header skeleton */}
            <tr className="brigade-header-row">
              <td colSpan={columnCount}>
                <div className="skeleton-brigade-header">
                  <div className="skeleton skeleton-brigade-icon"></div>
                  <div className="skeleton skeleton-brigade-name"></div>
                  <div className="skeleton skeleton-brigade-count"></div>
                </div>
              </td>
            </tr>

            {/* Employee rows skeleton */}
            {Array.from({ length: rowCount }).map((_, rowIndex) => (
              <tr key={rowIndex} className="employee-row">
                <td className="employee-info">
                  <div className="skeleton skeleton-employee-name"></div>
                  <div className="skeleton skeleton-employee-position"></div>
                </td>
                {[1, 2, 3, 4, 5, 6, 7].map((col) => (
                  <td key={col} className="color-cell">
                    <div className="skeleton skeleton-color-square"></div>
                  </td>
                ))}
                <td className="color-cell">
                  <div className="skeleton skeleton-color-square"></div>
                </td>
              </tr>
            ))}

            {/* Another brigade header skeleton */}
            <tr className="brigade-header-row">
              <td colSpan={columnCount}>
                <div className="skeleton-brigade-header">
                  <div className="skeleton skeleton-brigade-icon"></div>
                  <div className="skeleton skeleton-brigade-name-short"></div>
                  <div className="skeleton skeleton-brigade-count"></div>
                </div>
              </td>
            </tr>

            {/* More employee rows */}
            {Array.from({ length: 5 }).map((_, rowIndex) => (
              <tr key={`second-${rowIndex}`} className="employee-row">
                <td className="employee-info">
                  <div className="skeleton skeleton-employee-name"></div>
                  <div className="skeleton skeleton-employee-position"></div>
                </td>
                {[1, 2, 3, 4, 5, 6, 7].map((col) => (
                  <td key={col} className="color-cell">
                    <div className="skeleton skeleton-color-square"></div>
                  </td>
                ))}
                <td className="color-cell">
                  <div className="skeleton skeleton-color-square"></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HeatMapSkeleton;